/**
 * Synchronous key-value persistence (localStorage, a Capacitor Preferences mirror, memory).
 * Structurally identical to the game's KV so the same instance can be passed in.
 */
export interface KV {
  get(key: string): string | null;
  set(key: string, value: string): void;
  remove(key: string): void;
}

export class MemoryKV implements KV {
  readonly data = new Map<string, string>();
  get(key: string): string | null {
    return this.data.get(key) ?? null;
  }
  set(key: string, value: string): void {
    this.data.set(key, value);
  }
  remove(key: string): void {
    this.data.delete(key);
  }
}

export function readJson<T>(kv: KV, key: string): T | null {
  const raw = kv.get(key);
  return raw === null ? null : (JSON.parse(raw) as T);
}

export function writeJson(kv: KV, key: string, value: unknown): void {
  kv.set(key, JSON.stringify(value));
}
